const SelectLocationTypeLine = ({ LocationTypeLines, selectedlocationTypeLine, setSelectedLocationTypeLine }) => {
    return (
        <select
        id='location-type-line-select'
        className='choice-select'
        value={selectedlocationTypeLine}
        onChange={(e) => setSelectedLocationTypeLine(e.target.value)}
        >
            {selectedlocationTypeLine === '' ? <option value="">
                ------
            </option> : null}
            {LocationTypeLines.map((locationTypeLine) => (
                <option
                    key={locationTypeLine[1]}
                    value={locationTypeLine[0]}
                >
                    {locationTypeLine[1]}
                </option>
            ))}
        </select>
    );
};

export default SelectLocationTypeLine;